import { useMemo } from "react";
import getSearchParams from "./../utils/getSearchParams";
import useLocation from "./useLocation";
export default function useSearchParamsValue() {
  var _useLocation;
  var search = (_useLocation = useLocation()) === null || _useLocation === void 0 ? void 0 : _useLocation.search;
  var query = useMemo(function () {
    return getSearchParams(search !== null && search !== void 0 ? search : "");
  }, [search]);
  return query;
}